<template>
  <div>
    <div class="cursor-pointer">
      <component
        :is="'route' in item ? 'router-link' : 'a'"
        :to="'route' in item ? item.route : undefined"
        :href="'link' in item ? item.link : undefined"
        class="items-center font-medium inline-flex w-full transition-all"
        :class="[
          !sidebar.open ? 'justify-center' : 'justify-start',
          type === 'bottom'
            ? 'text-primary text-small sidebar-navigation-item-bottom rounded-lg'
            : 'text-white text-medium sidebar-navigation-item px-2 py-2 rounded-lg',
        ]"
        :target="'link' in item ? '_blank' : undefined"
        rel="noopener"
      >
        <div class="flex justify-center">
          <div v-if="item.icon">
            <MeridiaIcon
              v-if="
                [
                  'material-icons',
                  'material-icons-outlined',
                  'material-symbols',
                  'material-symbols-outlined',
                ].includes(item.icon.type)
              "
              :class="[
                {
                  'text-[20px]': type === 'bottom',
                  'text-[16px]': type !== 'bottom',
                  'w-5': type === 'bottom',
                  'w-4': type !== 'bottom',
                  'mr-xs': sidebar.open,
                },
              ]"
              :name="item.icon.value as string"
              :type="item.icon.type as any"
            />
            <div
              v-else-if="item.icon.type === 'component'"
              :class="[!sidebar.open ? '' : 'pr-2']"
            >
              <component
                :is="item.icon.value"
                :class="type === 'bottom' ? 'w-5 h-5' : 'w-4 h-4'"
                class="component-icon"
              />
            </div>
          </div>
          <div v-else>
            <span
              class="inline-flex items-center justify-center w-full text-base text-slate-600"
              >{{ item.name[0] }}</span
            >
          </div>
        </div>
        <Transition name="fade" :duration="open ? 150 : 0">
          <div
            v-if="open"
            class="inline-flex whitespace-nowrap overflow-hidden"
          >
            <div class="justify-center flex font-semibold">
              {{ type === 'bottom' ? item.name : item.name.toUpperCase() }}
            </div>
            <q-badge
              rounded
              class="ml-2 font-bold uppercase text-slate-950 text-[9px]"
              v-if="badge"
              >{{ badge }}</q-badge
            >
          </div>
        </Transition>
      </component>
    </div>
    <div
      v-for="child in item?.children"
      :key="child.name"
      class="my-2 transition-all"
      :class="[!open ? '' : 'ml-6']"
    >
      <SidebarNavigationItem
        v-if="
          'route' in child ? appStore.isRouteAuthorized(child.route.name) : true
        "
        :item="child"
        :type="type"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import {
  NavigationItem,
  NavigationItemGroupPosition,
} from 'src/core/types/app';
import { useAppStore } from 'src/core/stores/app';
import { useLocalStorage } from '@vueuse/core';
import { ref, watch } from 'vue';

const props = defineProps<{
  item: NavigationItem;
  type: NavigationItemGroupPosition;
  badge?: string;
}>();

const appStore = useAppStore();
const sidebar = useLocalStorage('sidebar', { open: true });
const open = ref(sidebar.value.open);
watch(sidebar, () => {
  if (sidebar.value.open) {
    setTimeout(() => (open.value = true), 150);
  } else {
    open.value = false;
  }
});

function isString(value: typeof props.item.icon) {
  return typeof value === 'string';
}
</script>

<style lang="scss" scoped>
.router-link-active.sidebar-navigation-item {
  @apply bg-primary;
  @apply text-slate-800 #{!important};

  .component-icon {
    @apply fill-slate-800;
  }
}

.router-link-active.sidebar-navigation-item-bottom {
  @apply underline;
}

.sidebar-navigation-item:hover {
  @apply bg-primary;
  @apply text-slate-800 #{!important};

  .component-icon {
    @apply fill-slate-800;
  }
}

.sidebar-navigation-item-bottom:hover {
  @apply underline;
}
</style>
